import React, {useState, useEffect} from 'react';
import {StyleProp, ViewStyle} from 'react-native';
import {TableRow} from '../table-row';
import LocalText from 'src/local';

export type AverageTimeRowProps = {
  averageTime?: number | undefined;
  containerStyle?: StyleProp<ViewStyle>;
};

export const AverageTimeRow: React.FC<AverageTimeRowProps> = ({
  averageTime,
  containerStyle,
}) => {
  const [text, setText] = useState<string>('');

  useEffect(() => {
    let string = '';
    if (averageTime) {
      let hours = Math.floor(averageTime / 60 / 60);
      let minutes = Math.floor(averageTime / 60 - hours * 60 * 60);
      let time = '';
      if (hours > 0) {
        time += `${hours}時`;
      }
      if (minutes > 0) {
        time += `${minutes}分`;
      }
      string = time;
    } else {
      string = '0分';
    }
    setText(string);
  }, [averageTime]);

  return (
    <TableRow
      containerStyle={[containerStyle]}
      text={LocalText.screens.offer.averageTimeRow.text}
      detail={text}
      sufix={''}
    />
  );
};
